export function UserAvatar({ user, size = 8 }) {
  const px = size * 4; // Tailwind size unit = 0.25rem = 4px
  const style = { width: px, height: px };
  if (user?.picture) {
    return <img src={user.picture} alt={user.name || "user"} data-testid="user-avatar" referrerPolicy="no-referrer" style={style} className="rounded-full border border-border object-cover" />;
  }
  return (
    <span data-testid="user-avatar" style={style} className="flex items-center justify-center rounded-full bg-primary/10 font-700 text-primary">
      {(user?.name || user?.email || "?").charAt(0).toUpperCase()}
    </span>
  );
}
